import { LRUCache } from "lru-cache";

const searchCache = new LRUCache({
    max: 50,
    allowStale: true,
    updateAgeOnGet: true,
});

export {searchCache}